export const toKilos = (value: number): string => {
  return `${value / 1000}K`;
};
